import { TextInput } from '@virtidev/toolbox';
import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
`;

export const SearchInput = styled(TextInput)`
  width: 10%;
  min-width: 150px;
  max-width: 350px;
  flex-grow: 1;
`;
